var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-container",
        [
          _c(
            "el-header",
            { attrs: { height: "42px" } },
            [
              _c("span", { staticClass: "ik-report-title" }, [
                _c(
                  "span",
                  { staticClass: "svg-container ik-report-icon" },
                  [_c("svg-icon", { attrs: { "icon-class": "database" } })],
                  1
                ),
                _vm._v(" 数据列表 "),
              ]),
              _c(
                "el-button-group",
                { staticClass: "ik-report-menu" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "ik-report-menu-btn",
                      attrs: { size: "medium" },
                    },
                    [_vm._v("新增")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "ik-report-menu-btn",
                      attrs: { size: "medium" },
                    },
                    [_vm._v("修改")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "ik-report-menu-btn",
                      attrs: { size: "medium" },
                    },
                    [_vm._v("详情")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "ik-report-menu-btn",
                      attrs: { size: "medium" },
                    },
                    [_vm._v("删除")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "ik-report-menu-btn",
                      attrs: { size: "medium" },
                    },
                    [_vm._v("导出")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "ik-report-menu-btn",
                      attrs: { size: "medium" },
                    },
                    [_vm._v("导入")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-main",
            [
              _c(
                "el-row",
                { staticClass: "table-title" },
                [
                  _c("el-col", { attrs: { span: 16 } }, [
                    _c("span", [_vm._v("分析报表")]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-footer",
            { attrs: { height: "40px" } },
            [
              _c(
                "el-row",
                { staticClass: "ik-report-info", attrs: { gutter: 0 } },
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "ik-report-enterprise-info",
                      attrs: { span: 12 },
                    },
                    [
                      _c("span", { staticStyle: { float: "left" } }, [
                        _vm._v(_vm._s(_vm.sysTitle)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }